import { ErrorOutline } from "@mui/icons-material";
import { Box, Button, Container, Typography, useTheme } from "@mui/material";

export const ErrorPage = () => {
	const theme = useTheme();
	const primaryColor =
		theme.components?.MuiButton?.styleOverrides?.textPrimary?.["&:hover"]
			.color ?? "#fff";

	return (
		<Box
			display="flex"
			flexDirection="column"
			textAlign="center"
			justifyContent="center"
		>
			<Container maxWidth="md">
				<ErrorOutline fontSize="large" />
				<Typography align="center" variant="h1" mb={4}>
					Uh-oh, we broke something!
				</Typography>
				<Typography align="center" variant="h4" mb={4}>
					Don't worry, our team of highly trained hamsters 🐹 is working on it.
				</Typography>
				<Button
					color="primary"
					variant="contained"
					onClick={() => window.location.replace("/")}
					disableElevation
					sx={{
						"&:hover": {
							color: `${primaryColor}`,
						},
					}}
				>
					Go Back to Home
				</Button>
			</Container>
		</Box>
	);
};
